import service from '../request/index'

// 我的金额统计
export function amountStatistics () {
  return service({
    url: '/es/resource/my/amount/statistics',
    method: 'GET',
  })
}

// 提现记录
export function withdrawalRecord (data) {
  return service({
    url: '/es/resource/my/withdrawal/record',
    method: 'post',
    data
  })
}

// 认证信息
export function accountInfo () {
  return service({
    url: '/es/resource/my/account/info',
    method: 'get',
  })
}

// 稿费收入账单
export function annualAccount (data) {
  return service({
    url: '/es/resource/my/annual/account',
    method: 'get',
    params:data
  })
}
// 开票记录
export function invoiceRecord (data) {
  return service({
    url: '/es/resource/my/invoice/record',
    method: 'get',
    params:data,
  })
}

// 开发票
export function invoice (data) {
  return service({
    url: '/es/resource/my/invoice',
    method: 'post',
    data
  })
}

//提现
export function withdrawal (data) {
  return service({
    url: '/es/resource/my/withdrawal',
    method: 'post',
    data
  })
}